import React from 'react';
import AppImage from '../AppImage';

const Logo = () => {
  return (
    <div className="absolute top-4 left-4 z-50">
      <AppImage
        src="/assets/images/High-Resolution-Color-Logo-1769439592151.png"
        alt="TrainaryGym Logo"
        className="h-12 w-auto object-contain"
      />
    </div>
  );
};

export default Logo;